import { createSyncAction, IBaseAction } from '@bimser/core';
import * as ActionTypes from './actionTypes';

export default function closeModalFrameAction(): IBaseAction<any> {
	const action = createSyncAction(ActionTypes.CLOSE_MODAL_FRAME, null);

	return action;
}
